import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import LeaderBoard from './pages/LeaderBoard';

function App() {
  return (
    <Router>
      <div className="d-flex" style={{ marginTop: '20px' }}>
        <div class="container-fluid">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/leaderboard" element={<LeaderBoard />} />
            <Route path="/leaderboard/:id" element={<LeaderBoard />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
